import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReasonsModel } from '../model/reasons.model';
import { ReasonsService } from '../reasons.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';
@Component({
  selector: 'app-reasons-edit',
  templateUrl: './reasons-edit.component.html',
  styleUrls: ['./reasons-edit.component.scss'],
  standalone: false
})
export class ReasonsEditComponent implements DirtyCheck {
  title: string = "New Reason";
  editForm!: FormGroup;
  reasonsInfo: ReasonsModel = {};
  isFormDirty: boolean = false;
  ratingList: ReasonsModel[] = [];
  context: any;
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private reasonsService: ReasonsService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {

    let reasonsId = this.route.snapshot.paramMap.get('id');


    if (reasonsId !== null && parseInt(reasonsId) !== 0) {
      this.setReasonsInfo(reasonsId);
    }
    else {
      this.initForm();
    }
    this.getContext();
    this.permission = permissionService.getPagePermission("reason");
  }
  ngOnInit(): void {
    //  this.loadRating();


  }

  getContext() {
    this.reasonsService.getContextList().subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.context = response.data.context;
          this.initForm();
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get expense type from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  initForm() {
    this.editForm = this.builder.group({
      code: this.builder.control(this.reasonsInfo.code, [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(this.reasonsInfo.name, [Validators.required, Validators.maxLength(50)]),
      description: this.builder.control(this.reasonsInfo.description),
      context: this.builder.control(Number(this.reasonsInfo.context))
    });
    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });
  }

  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/system/reason']);

  }

  /**
   * If tas is is null set an empty reasons info
   * if reasons id is not null call api to rtrive the info
   * @param reasonsId 
   */
  setReasonsInfo(reasonsId: any): void {

    let response = this.reasonsService.getReasonsById(reasonsId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.reasonsInfo = response.data.reasons;
          this.editForm.patchValue(this.reasonsInfo);
          this.title = this.getTitle();
          this.initForm();
          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.reasonsInfo.id == 0 || this.reasonsInfo.id == undefined) ? "New Reason" : "Editing : " + this.reasonsInfo.name;
    return title;
  }

  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {

    if (this.editForm.valid) {
      this.editForm.markAllAsTouched();
      Object.assign(this.reasonsInfo, this.editForm.value);
      this.reasonsService.update(this.reasonsInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.reasonsInfo.name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
            this.router.navigate(['/system/reason']);

          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);


          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });

    } else {
      this.editForm.markAllAsTouched();
    }
  }

}
